import React from 'react';
import PropTypes from 'prop-types';

const EditGridItem = props => {
  const handleEditClick = () => {
    props.updateGridTitle(props.index, props.gridType);
  };
  return (
    <button className="editTitle" onClick={handleEditClick}>
      Edit Name
    </button>
  );
};

EditGridItem.prototypes = {
  updatedIndex: PropTypes.number,
  gridType: PropTypes.string,
  updateGridTitle: PropTypes.func,
};

export default EditGridItem;
